import angular from 'angular';
import angularAnimate from 'angular-animate';
import angularAria from 'angular-aria';
import angularMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';


import Config from './config/config';
import mdDateLocaleConfig from './config/md-date-locale-provider-config';
import mdThemingConfig from './config/md-theming-provider-config';
import translateConfig from './config/translate-provider-config';
import restangularConfig from './config/restangular-config';
import textangularConfig from './config/textangular-config';

import uiMasks from 'angular-input-masks';
import angularTranslate from 'angular-translate';
import 'angular-avatar';
import 'lodash';
import 'restangular';
import 'ngstorage';
import ngMessages from 'angular-messages';
import ngMaterialDatePicker from 'ng-material-datetimepicker';
import mdDataTable from 'angular-material-data-table';
import 'textangular/dist/textAngular-sanitize.min';
import textAngular from 'textangular';
import 'imports?this=>window,exports=>false,define=>false!ui-cropper';
import 'ngmap'
import 'angular-chart.js'

import 'normalize.css';
import 'mdi/css/materialdesignicons.css';
import 'angular-material/angular-material.css';
import 'angular-material-data-table/dist/md-data-table.min.css';
import 'textangular/dist/textAngular.css';
import 'font-awesome/css/font-awesome.min.css';

angular.module('app', [
  angularAnimate,
  angularAria,
  angularMaterial,
  angularTranslate,
  Common,
  Components,
  mdDataTable,
  'ngAvatar',
  'ngMap',
  ngMaterialDatePicker,
  ngMessages,
  'ngStorage',
  'restangular',
  textAngular,
  'uiCropper',
  uiRouter,
  uiMasks,
  'chart.js'
])
  .config(Config)
  .config(mdDateLocaleConfig)
  .config(mdThemingConfig)
  .config(translateConfig)
  .config(restangularConfig)
  .config(textangularConfig)

  .run(($rootScope) => {
    "ngInject";

    // Because we have difficulties accessing the asssets folder with AWS s3 web hosting
    //$rootScope.baseAssetsUrl = 'https://s3-sa-east-1.amazonaws.com/sabin-backoffice-prod/assets';
    $rootScope.baseAssetsUrl = 'assets';
  })

  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js